import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import {
  contractsStatuses,
  contractsTypes
} from '../../utils/constants/tagColors';
import { routes, subRoutes } from '../../utils/constants/routes';
import useAuthContext from '../../contexts/AuthContext';

const useColumns = () => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const isCustomer = user?.role === 'guests:GUEST';

  return [
    ...(isCustomer
      ? []
      : [
          {
            title: t('contracts.column.client'),
            dataIndex: 'customer',
            key: 'customer',
            render: (customer, { key }) => (
              <Link
                to={`${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CLIENTS}/show/${key}`}
              >
                {customer && `${customer.first_name} ${customer.last_name}`}
              </Link>
            ),
            sorter: true
          }
        ]),
    {
      title: t('contracts.column.number'),
      dataIndex: 'number',
      key: 'number',
      render: (number, { key }) => (
        <Link
          to={`${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS}/show/${key}`}
        >
          {number}
        </Link>
      ),
      sorter: true
    },
    {
      title: t('contracts.column.contractType'),
      dataIndex: 'type',
      key: 'type',
      render: (contractType) => (
        <Tag color={contractsTypes[contractType]}>
          {t(`contracts.tags.${contractType}`)}
        </Tag>
      ),
      sorter: true,
      width: 100
    },
    {
      title: t('contracts.form.contract_status'),
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={contractsStatuses[status]}>
          {t(`contracts.tags.${status}`)}
        </Tag>
      ),
      sorter: true
    },
    {
      title: t('contracts.column.start_date'),
      dataIndex: 'effective_date',
      key: 'effective_date',
      render: (date) => date && moment(date).format('L'),
      sorter: true
    },
    ...(isCustomer
      ? []
      : [
          {
            title: t('contracts.column.exemption_link'),
            dataIndex: 'exemption_link',
            key: 'exemption_link',
            render: (exemption_link) =>
              exemption_link
                ? t('quotes.form.switch.true')
                : t('quotes.form.switch.false'),
            sorter: true
          }
        ])
  ];
};

export default useColumns;
